<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="dabef9d1bfb79-d1e352"><span id="pagev">
<p class="dedication-first"><em class="italic ">To the one where the honour lies</em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106403_epub_ded.vue?32de6918